import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  initialValue?: string;
}

export const InputSuffix: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item label="Suffix:">
    {form.getFieldDecorator('suffix', {
      initialValue,
      rules: [{ required: false }],
    })(<Input allowClear placeholder="Suffix (MD, DO, PA, ect.)" />)}
  </Form.Item>
);
